import "./Hero.scss";
import "../Download/Download.scss";
import { useContext } from "react";
import { LangContext } from "../../context/langContext";
import appStoreBadge from "../../assets/app-store-badge.webp";
import appStoreBadgeEn from "../../assets/app-store-badge-en.webp";
import googlePlayBadge from "../../assets/google-play-badge.webp";
import googlePlayBadgeEn from "../../assets/google-play-badge-en.webp";

const NewHero = ({ textData }) => {
  const lang = useContext(LangContext);

  return (
    <section className="hero">
      <h1 className="hero__title">{textData[lang].hero.title}</h1>
      <p className="hero__subtitle">{textData[lang].hero.subtitle}</p>
      <div className="download-links download-links_hero">
        <a
          href="https://apps.apple.com/kz/app/totem-chat/id6444722452"
          className="download-links__item"
        >
          <img
            src={lang === "RU" ? appStoreBadge : appStoreBadgeEn}
            alt="app store"
            className="download-links__icon"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=kz.mobile.totemchat&hl=ru&gl=US"
          className="download-links__item"
        >
          <img
            src={lang === "RU" ? googlePlayBadge : googlePlayBadgeEn}
            alt="google play"
            className="download-links__icon"
          />
        </a>
      </div>
    </section>
  );
};

export default NewHero;
